import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const RowSpaced = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	gap: 2.4rem;
	padding: var(--padding-5) var(--padding-3);
	border: 1px solid var(--border-color);
	border-radius: var(--small-border-radius);
	cursor: default;
	body[dir='rtl'] & {
		margin-right: unset;
		margin-left: var(--margin-1);
	}
	@media ${Breakpoints.mobile} {
		flex-shrink: 1;
	}
`;

export const StoreInfo = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.9rem;
`;

export const StoreName = styled.div`
	display: flex;
	gap: 0.5rem;
`;

export const IntegrationName = styled.div`
	display: flex;
	justify-content: space-between;
	gap: 2rem;

	@media ${Breakpoints.mobile} {
		flex-direction: column;
		gap: 1rem;
	}
`;

export const RowCentered = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 2rem;
`;

export const RowCenteredActions = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	padding: var(--padding-1);
	gap: var(--padding-3);

	@media ${Breakpoints.mobile} {
		padding: 0;
		> button {
			margin: 0;
		}
	}
`;
export const PartnersContainer = styled.div`
	transition: all 0.3s;
	background: var(--white);
	height: auto;
	overflow-x: auto;
	.emptySubtitle {
		margin: 2.5rem auto !important;
	}
	display: flex;
	flex-direction: column;
	gap: 2.5rem;
`;

export const InputContainer = styled.div`
	width: 100%;
	position: relative;
	margin-bottom: 4.3rem;
	body[dir='rtl'] & {
		text-align: right;
	}
`;

export const LoadingRowSpaced = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	padding: var(--padding-5) var(--padding-3);
	margin-top: var(--margin-2);
	margin-bottom: var(--margin-2);
	border: 1px solid var(--border-color);
	border-radius: var(--small-border-radius);

	@media ${Breakpoints.mobile} {
		padding: var(--padding-3);
	}
`;

export const LoadingRowCenteredActions = styled.div`
	display: flex;
	align-items: center;
	gap: var(--padding-3);

	@media ${Breakpoints.mobile} {
		gap: var(--padding-2);
	}
`;

export const LoadingRowCentered = styled.div`
	display: flex;
	align-items: center;
	gap: 1.7rem;
`;

export const Menu = styled.ul`
	list-style: none;
	padding: 0;
	margin: 0;
	background-color: var(--modal-bg-3);
	box-shadow: var(--container-box-shadow);
	border-radius: var(--small-border-radius);
	padding: var(--padding-2);

	@media ${Breakpoints.mobile} {
		padding: var(--padding-4) 0;
	}
`;

export const MenuItem = styled.li`
	display: flex;
	align-items: center;
	gap: 0.5rem;
	cursor: pointer;
	background-color: var(--modal-bg-3);
	padding: var(--padding-2) var(--padding-3);
	border-radius: var(--small-border-radius);

	&.disabled {
		background: #0000001f 0% 0% no-repeat padding-box;
		color: #00000042;
		-webkit-text-fill-color: #00000042;
		opacity: 1;
		cursor: not-allowed;

		> .typography {
			color: #00000042;
		}
	}
	@media ${Breakpoints.mobile} {
		background-color: var(--background-3);
		margin: var(--padding-3);
		> .typography {
			font-weight: 500;
		}
	}

	:first-of-type {
		border-top-left-radius: var(--small-border-radius);
		border-top-right-radius: var(--small-border-radius);
	}

	:last-of-type {
		border-bottom-left-radius: var(--small-border-radius);
		border-bottom-right-radius: var(--small-border-radius);
	}

	&:hover:not(.disabled) {
		background-color: var(--table-selected-color);
	}
`;

export const Separator = styled.div`
	border-left: 1px solid var(--border-color);
	align-self: stretch;
`;

export const LoadingContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
`;

export const LoadingMetaWrapper = styled.div`
	display: flex;
	gap: 0.8rem;
`;
